/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum StatisticsIntervalTypeEnum {
    AllTime = 'allTime',
    LastYearBeginning = 'lastYearBeginning',
    ThisYearBeginning = 'thisYearBeginning',
    ThisMonthBeginning = 'thisMonthBeginning',
    LastThirtyDays = 'lastThirtyDays',
    LastSevenDays = 'lastSevenDays',
    LastQuarter = 'lastQuarter',
    Today = 'today'
}

export function StatisticsIntervalTypeEnumFromJSON(json: any): StatisticsIntervalTypeEnum {
    return StatisticsIntervalTypeEnumFromJSONTyped(json, false);
}

export function StatisticsIntervalTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsIntervalTypeEnum {
    return json as StatisticsIntervalTypeEnum;
}

export function StatisticsIntervalTypeEnumToJSON(value?: StatisticsIntervalTypeEnum | null): any {
    return value as any;
}

